import { Box } from "@vapor/react-material";
import { ActiveCustomersBubble } from "./bubbles-components/ActiveCustomersBubble";
import { ApplicationsBubble } from "./bubbles-components/ApplicationsBubble";
import { HandledInvoicesBubble } from "./bubbles-components/HandledInvoicesBubble";

export const Bubbles = () => (
    <Box
        sx={{
            display: "flex",
            alignItems: "center",
            gridGap: "16px",
            marginTop: "40px",
        }}
    >
        <HandledInvoicesBubble />
        <ActiveCustomersBubble />
        <ApplicationsBubble />
    </Box>
);
